"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupPolyfills = void 0;
function setupPolyfills() {
    if (!Object.fromEntries) {
        Object.fromEntries = function (entries) {
            if (!entries || !entries[Symbol.iterator]) {
                throw new Error('Object.fromEntries() requires a single iterable argument');
            }
            var obj = {};
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], key = _a[0], value = _a[1];
                obj[key] = value;
            }
            return obj;
        };
    }
}
exports.setupPolyfills = setupPolyfills;
